import { topics } from '@/mocks/home';

const colorMap: Record<string, string> = {
  primary: 'bg-primary-500/12 text-primary-400 border-primary-500/25',
  accent: 'bg-accent-500/12 text-accent-400 border-accent-500/25',
  secondary: 'bg-secondary-500/12 text-secondary-400 border-secondary-500/25',
};

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 tracking-wide">热门话题</h2>
          <p className="mt-2 text-sm text-foreground-500">发现当下最受欢迎的影视分类，找到属于你的观影偏好</p>
        </div>
        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic) => (
            <div
              key={topic.label}
              className={`flex items-center gap-2 px-4 py-2.5 rounded-full border cursor-pointer transition-all duration-200 hover:scale-105 ${colorMap[topic.color] || colorMap.primary}`}
            >
              <span className="text-sm font-medium whitespace-nowrap">{topic.label}</span>
              <span className="text-xs opacity-70">{topic.count}</span>
              {topic.tag === 'hot' && (
                <span className="text-[10px] px-1.5 py-0.5 rounded-full bg-primary-500/20 text-primary-400 whitespace-nowrap">
                  热门
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}